document.addEventListener("DOMContentLoaded", function () {

  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector("#scroll360");
  if (!section) return;

  const frames = gsap.utils.toArray(".scroll-360-frame");
  const blocks = gsap.utils.toArray(".scroll-360-block");

  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  const groupSize = isMobile ? 3 : 2;
  const totalFrames = frames.length;
  const totalGroups = Math.ceil(blocks.length / groupSize);

  const SCROLL_PER_GROUP = 900;

  /* Assign positions */
  blocks.forEach((block, index) => {

    if (isMobile) {
      const pattern = index % 3;
      if (pattern === 0) block.classList.add("pos-left");
      if (pattern === 1) block.classList.add("pos-top");
      if (pattern === 2) block.classList.add("pos-right");
    } else {
      const pattern = index % 2;
      if (pattern === 0) block.classList.add("pos-left");
      if (pattern === 1) block.classList.add("pos-right");
    }

    // 👇 ONLY opacity (no transform)
    gsap.set(block, { autoAlpha: 0 });
  });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top top",
      end: "+=" + (totalGroups * SCROLL_PER_GROUP),
      scrub: 0.8,
      pin: true,
      anticipatePin: 1
    }
  });

  /* Frame rotation */
  const frameObj = { frame: 0 };

  tl.to(frameObj, {
    frame: totalFrames - 1,
    ease: "none",
    duration: totalGroups,
    onUpdate: function () {
      const frameIndex = Math.round(frameObj.frame);
      frames.forEach((img, i) => {
        img.style.opacity = i === frameIndex ? 1 : 0;
      });
    }
  }, 0);

  /* Block animation */
  let previousGroup = null;

  for (let g = 0; g < totalGroups; g++) {

    const groupStart = g;
    const group = blocks.slice(g * groupSize, g * groupSize + groupSize);

    // fade out previous
    if (previousGroup) {
      tl.to(previousGroup, {
        autoAlpha: 0,
        duration: 0.3,
        ease: "power2.inOut"
      }, groupStart);
    }

    // fade in current
    group.forEach((block, i) => {
      tl.to(block, {
        autoAlpha: 1,
        duration: 0.35,
        ease: "power2.out"
      }, groupStart + 0.2 + (i * 0.2));
    });

    previousGroup = group;
  }

});